/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Light_Warm_Newt_LimpInputs */

const en_light_warm_newt_limp = /** @type {(inputs: Light_Warm_Newt_LimpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Created at ${i?.date}`)
};

const de_light_warm_newt_limp = /** @type {(inputs: Light_Warm_Newt_LimpInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erstellt am ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Created at {date}" |
*
* @param {Light_Warm_Newt_LimpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const light_warm_newt_limp = /** @type {((inputs: Light_Warm_Newt_LimpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Light_Warm_Newt_LimpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_light_warm_newt_limp(inputs)
	return de_light_warm_newt_limp(inputs)
});